import axios from "axios";
import { API_BASE_URL, API_ENDPOINTS } from "../config/api";

const TOKEN_KEY = "sensify_token";
const REFRESH_TOKEN_KEY = "sensify_refresh_token";

export const authService = {
  login: async (username: string, password: string): Promise<string> => {
    const res = await axios.post(`${API_BASE_URL}/Auth/Login`, {
      userName: username,
      userPassword: password,
    });
    const accessToken: string = res.data.accessToken;
    const refreshToken: string = res.data.refreshToken;
    localStorage.setItem(TOKEN_KEY, accessToken);
    localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
    return accessToken;
  },

  logout: async () => {
    try {
      const token = localStorage.getItem(TOKEN_KEY);
      if (token) await axios.post(`${API_BASE_URL}/Auth/Logout`, {}, { headers: { Authorization: `Bearer ${token}` } });
    } catch { }
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(REFRESH_TOKEN_KEY);
  },

  refresh: async (): Promise<string | null> => {
    const refreshToken = localStorage.getItem(REFRESH_TOKEN_KEY);
    if (!refreshToken) return null;
    try {
      const res = await axios.post(`${API_BASE_URL}/Auth/Refresh`, { refreshToken });
      const accessToken: string = res.data.accessToken;
      localStorage.setItem(TOKEN_KEY, accessToken);
      localStorage.setItem(REFRESH_TOKEN_KEY, res.data.refreshToken);
      return accessToken;
    } catch {
      authService.logout();
      return null;
    }
  },

  getToken: (): string | null => localStorage.getItem(TOKEN_KEY),

  isAuthenticated: (): boolean => !!localStorage.getItem(TOKEN_KEY),

  checkTokenValid: async (token: string): Promise<boolean> => {
    const res = await axios.get(API_ENDPOINTS.checkTokenValid(token));
    return res.data?.data === true;
  },

  setPassword: async (token: string, newPassword: string): Promise<void> => {
    await axios.post(API_ENDPOINTS.setPassword, { token, newPassword });
  },

  sendPasswordReset: async (email: string): Promise<void> => {
    await axios.post(API_ENDPOINTS.sendPasswordReset, { email });
  },
};
